module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subcat-label-block"
  }, [_c('div', {
    staticClass: "subcat-label",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleIndicators,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.toggleIndicators($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        _vm.toggleIndicators($event)
      }]
    }
  }, [_c('i', {
    staticClass: "fa collapse-icon",
    class: _vm.collapseIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.subcategory.name) + "\n")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subcategory.showCurrentIndicators),
      expression: "subcategory.showCurrentIndicators"
    }],
    staticClass: "indicators-block",
    attrs: {
      "aria-hidden": !_vm.subcategory.showCurrentIndicators
    }
  }, _vm._l((_vm.subcategory.indicators), function(indicator) {
    return _c('legend-indicator', {
      key: _vm._f("makeID")(indicator.name),
      attrs: {
        "indicator": indicator
      }
    }, [_vm._v("\n          " + _vm._s(indicator.name) + "\n      ")])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b7d0b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/heat-map-legend/LegendSubcatBlock.vue
// module id = 533
// module chunks = 1